export default Object.freeze({
  UNIQUE_IDS_LIST: 'UNIQUE_IDS_LIST',
  UNIQUE_ID_DELETE: 'UNIQUE_ID_DELETE',
});
